export enum DealerCacheTagType {
  DealersByClientId = 'dealersByClientId',
  DealersByGroup = 'dealersByGroup',
  Dealer = 'dealer',
}
